import Footer from "../../component/Footer";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import AgentNavbar from "../../component/AgentNavbar";
import { ChevronRight } from "react-feather"; // Importing icons
import { baseurl } from "../../component/Baseurl";
import axios from 'axios';
import Swal from 'sweetalert2';  // Import SweetAlert2

function AgentAddMarkup() {
  // Initialize state for each section (flight, hotel, bus)
  const [flightMarkupType, setFlightMarkupType] = useState("In Amount");
  const [hotelMarkupType, setHotelMarkupType] = useState("In Amount");
  const [busMarkupType, setBusMarkupType] = useState("In Amount");

  const [flightAmount, setFlightAmount] = useState('');
  const [flightPercent, setFlightPercent] = useState('');
  const [hotelAmount, setHotelAmount] = useState('');
  const [hotelPercent, setHotelPercent] = useState('');
  const [busAmount, setBusAmount] = useState('');
  const [busPercent, setBusPercent] = useState('');

  const agentid = localStorage.getItem("agent_id");

  // Fetch markup details when component mounts
  useEffect(() => {
    const fetchMarkupDetails = async () => {
      try {
        const response = await axios.get(`${baseurl}getMarkupDetails/${agentid}`);
        const data = response.data.data;

        // Set the state with fetched data
        setFlightMarkupType(data.flight_markup_type);
        setFlightAmount(data.flight_markup_amount);
        setFlightPercent(data.flight_markup_percent);

        setHotelMarkupType(data.hotel_markup_type);
        setHotelAmount(data.hotel_markup_amount);
        setHotelPercent(data.hotel_markup_percent);

        setBusMarkupType(data.bus_markup_type);
        setBusAmount(data.bus_markup_amount);
        setBusPercent(data.bus_markup_percent);
      } catch (error) {
        console.error("Error fetching markup details:", error);
        // Swal.fire({
        //   icon: 'error',
        //   title: 'Failed to fetch markup details',
        //   text: error.response?.data?.message || 'Please try again.',
        // });
      }
    };

    fetchMarkupDetails();
  }, [agentid]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Build the payload with the correct markup types and amounts/percentages
    const payload = {
      agent_id: agentid, // Add agent ID to payload
      flight_markup_type: flightMarkupType,
      flight_markup_amount: flightMarkupType === 'In Amount' ? flightAmount : null,
      flight_markup_percent: flightMarkupType === 'In Percent' ? flightPercent : null,
      
      hotel_markup_type: hotelMarkupType,
      hotel_markup_amount: hotelMarkupType === 'In Amount' ? hotelAmount : null,
      hotel_markup_percent: hotelMarkupType === 'In Percent' ? hotelPercent : null,
      
      bus_markup_type: busMarkupType,
      bus_markup_amount: busMarkupType === 'In Amount' ? busAmount : null,
      bus_markup_percent: busMarkupType === 'In Percent' ? busPercent : null,
    };
  
    console.log("Payload data being sent:", payload); // Console log to check the payload
  
    try {
      const response = await axios.post(`${baseurl}markup`, payload);
      console.log("Response from server:", response); // Console log to check the server response
  
      Swal.fire({
        icon: 'success',
        title: 'Markup saved successfully!',
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      console.error("Error submitting markup:", error);
      Swal.fire({
        icon: 'error',
        title: 'Something went wrong',
        text: error.response?.data?.message || 'Please try again.',
      });
    }
  };
  

  return (
    <>
      <AgentNavbar />
      <div className="bgagent">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center" >
            <h1 className="text-start agenth1 pt-3 font4">
              <span>My Profile</span>
            </h1>

            <span className="text-muted">
              Dashboard <ChevronRight size={12} /> Change Password
            </span>
          </div>

          <div className="row g-3 justify-content-center">
            <div className="col-md-9">
              <div className="crdmain p-3">
                <form className="text-start" onSubmit={handleSubmit}>
                  {/* Flight Booking */}
                  <div className="row g-2 mt-4 mb-1">
                    <div className="col-md-12">
                      <label className="text-dark mb-2 labelset1 font3"><strong className="kma2">Markup On Flight Booking</strong></label>
                    </div>

                    <div className="col-md-6">
                      <label className="text-dark mb-2 labelset1 font3">Select Markup Type</label>
                      <select
                        className="input1"
                        value={flightMarkupType}
                        onChange={(e) => setFlightMarkupType(e.target.value)}
                      >
                        <option>In Amount</option>
                        {/* <option>In Percent</option> */}
                      </select>
                    </div>

                    {/* Conditionally render Amount or Percent for Flight */}
                    {flightMarkupType === "In Amount" ? (
                      <div className="col-md-6">
                        <label className="text-dark mb-2 labelset1 font3">Enter Amount</label>
                        <input
                          type="text"
                          className="input1"
                          value={flightAmount}
                          onChange={(e) => setFlightAmount(e.target.value)}
                          placeholder="Enter Amount"
                        />
                      </div>
                    ) : (
                      <div className="col-md-6">
                        <label className="text-dark mb-2 labelset1 font3">Enter Percent</label>
                        <input
                          type="text"
                          className="input1"
                          value={flightPercent}
                          onChange={(e) => setFlightPercent(e.target.value)}
                          placeholder="Enter Percent"
                        />
                      </div>
                    )}
                  </div>

                  {/* Hotel Booking */}
                  <div className="row g-2 mt-4 mb-4">
                    <div className="col-md-12">
                      <label className="text-dark mb-2 labelset1 font3"><strong className="kma2">Markup On Hotel Booking</strong></label>
                    </div>

                    <div className="col-md-6">
                      <label className="text-dark mb-2 labelset1 font3">Select Markup Type</label>
                      <select
                        className="input1"
                        value={hotelMarkupType}
                        onChange={(e) => setHotelMarkupType(e.target.value)}
                      >
                        <option>In Amount</option>
                        {/* <option>In Percent</option> */}
                      </select>
                    </div>

                    {/* Conditionally render Amount or Percent for Hotel */}
                    {hotelMarkupType === "In Amount" ? (
                      <div className="col-md-6">
                        <label className="text-dark mb-2 labelset1 font3">Enter Amount</label>
                        <input
                          type="text"
                          className="input1"
                          value={hotelAmount}
                          onChange={(e) => setHotelAmount(e.target.value)}
                          placeholder="Enter Amount"
                        />
                      </div>
                    ) : (
                      <div className="col-md-6">
                        <label className="text-dark mb-2 labelset1 font3">Enter Percent</label>
                        <input
                          type="text"
                          className="input1"
                          value={hotelPercent}
                          onChange={(e) => setHotelPercent(e.target.value)}
                          placeholder="Enter Percent"
                        />
                      </div>
                    )}
                  </div>

                  {/* Bus Booking */}
                  <div className="row g-2 mt-4 mb-4">
                    <div className="col-md-12">
                      <label className="text-dark mb-2 labelset1 font3"><strong className="kma2">Markup On Bus Booking</strong></label>
                    </div>

                    <div className="col-md-6">
                      <label className="text-dark mb-2 labelset1 font3">Select Markup Type</label>
                      <select
                        className="input1"
                        value={busMarkupType}
                        onChange={(e) => setBusMarkupType(e.target.value)}
                      >
                        <option>In Amount</option>
                        {/* <option>In Percent</option> */}
                      </select>
                    </div>

                    {/* Conditionally render Amount or Percent for Bus */}
                    {busMarkupType === "In Amount" ? (
                      <div className="col-md-6">
                        <label className="text-dark mb-2 labelset1 font3">Enter Amount</label>
                        <input
                          type="text"
                          className="input1"
                          value={busAmount}
                          onChange={(e) => setBusAmount(e.target.value)}
                          placeholder="Enter Amount"
                        />
                      </div>
                    ) : (
                      <div className="col-md-6">
                        <label className="text-dark mb-2 labelset1 font3">Enter Percent</label>
                        <input
                          type="text"
                          className="input1"
                          value={busPercent}
                          onChange={(e) => setBusPercent(e.target.value)}
                          placeholder="Enter Percent"
                        />
                      </div>
                    )}
                  </div>

<div className="text-end"><button type="submit" className="btn btn-primary">Save Markup</button></div>
                  
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default AgentAddMarkup;
